import { pathExists } from 'fs-extra';
import { FileWriter } from '../../utils/file-writer';
import { Logger } from '../../utils/logger';
import { ErrorUpdaterAngular15 } from './error-updater-angular15';

/**
 * the log parser class.
 */
export class LogParser {
    private filePath: string;
    private fileWriter: FileWriter;
    private errorUpdaterAngular15: ErrorUpdaterAngular15;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     * @param fileName the file name.
     */
    constructor(filePath: string, fileName?: string) {
        this.update(filePath, fileName);

        this.errorUpdaterAngular15 = new ErrorUpdaterAngular15();
    }

    /**
     * the update function.
     * @param filePath the file path.
     * @param fileName the file name.
     */
    public update(filePath: string, fileName?: string) {
        this.filePath = filePath;
        this.messages.notFound = `${fileName} not found at ${this.filePath}.`
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                await this.errorUpdaterAngular15.resolveLogBuildErrors(this.fileWriter.getData());
                await this.errorUpdaterAngular15.resolveLogBuildWarnings(this.fileWriter.getData());
            } else {
                Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
